import { render, staticRenderFns } from "./FormControlDefault.vue?vue&type=template&id=256f9020"
import script from "./FormControlDefault.vue?vue&type=script&lang=js"
export * from "./FormControlDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports